import { Box, IconButton, InputBase } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import { ACCENT_BLUE } from 'utils/brand-colors'

type DriverCountStepperProps = {
  value: number
  min: number
  onChange: (value: number) => void
}

const parseInteger = (raw: string, fallback: number) => {
  if (!/^\d+$/.test(raw.trim())) {
    return fallback
  }
  return parseInt(raw, 10)
}

const DriverCountStepper = ({ value, min, onChange }: DriverCountStepperProps) => {
  const setValue = (next: number) => {
    if (!Number.isInteger(next) || next < min) {
      onChange(min)
      return
    }
    onChange(next)
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        border: '1px solid #d7dce3',
        borderRadius: '12px',
        overflow: 'hidden',
        height: 56,
      }}
    >
      <IconButton
        aria-label="Decrease drivers"
        onClick={() => setValue(value - 1)}
        disabled={value <= min}
        sx={{ width: 56, height: 56, borderRadius: 0, color: ACCENT_BLUE }}
      >
        <RemoveIcon />
      </IconButton>
      <InputBase
        value={value}
        inputProps={{
          inputMode: 'numeric',
          pattern: '[0-9]*',
          'aria-label': 'Number of drivers',
          style: { textAlign: 'center', fontWeight: 700, fontSize: 22 },
        }}
        onChange={(event) => {
          const next = parseInteger(event.target.value, value)
          setValue(next)
        }}
        onBlur={() => setValue(value)}
        sx={{ flex: 1 }}
      />
      <IconButton
        aria-label="Increase drivers"
        onClick={() => setValue(value + 1)}
        sx={{ width: 56, height: 56, borderRadius: 0, color: ACCENT_BLUE }}
      >
        <AddIcon />
      </IconButton>
    </Box>
  )
}

export default DriverCountStepper
